import * as HttpService from '../HttpService'

let namespace = 'http://www.carimagery.com/api.asmx/GetImageUrl?searchTerm='

let find = (makeAndModel, options, cb, errorCb) => {
    HttpService.get(namespace + makeAndModel, options, cb, errorCb)
}

export {
    find
}



// WEBPACK FOOTER //
// ./src/services/image/imageService.js